var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFormulaList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 34,
    viewBox: "0 0 23 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6904 2.21582V15.0986L14.499 15.3779C18.4307 16.7352 21.252 20.4683 21.252 24.8574C21.2519 27.8646 19.9286 30.561 17.8291 32.4004C17.8155 32.4123 17.7994 32.418 17.7842 32.418H4.66797C4.65258 32.418 4.63568 32.4123 4.62207 32.4004H4.62305C2.52353 30.5609 1.20027 27.8646 1.2002 24.8574C1.2002 20.8527 3.54838 17.3938 6.94824 15.7871C8.05148 15.2656 8.76172 14.1556 8.76172 12.9287V2.21582H13.6904Z",
    stroke: "url(#paint0_linear_25864_18912)",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4231 2.02978H4.8313C4.27077 2.02978 3.81641 1.57542 3.81641 1.01489C3.81641 0.454368 4.27084 0 4.8313 0H17.4231C17.9837 0 18.438 0.454368 18.438 1.01489C18.438 1.57542 17.9836 2.02978 17.4231 2.02978Z",
    fill: "url(#paint1_linear_25864_18912)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 24.4076C3.19922 26.7801 4.23232 28.911 5.87287 30.376C6.07096 30.5528 6.3272 30.6508 6.59274 30.6508H15.8057C16.0712 30.6508 16.3275 30.5528 16.5256 30.376C18.1661 28.911 19.1992 26.7801 19.1992 24.4076C19.1992 22.9079 18.7863 21.5048 18.0683 20.3053C17.9587 20.1223 17.7623 20.0088 17.5489 20.0088H4.8496C4.63622 20.0088 4.43977 20.1223 4.3302 20.3053C3.61213 21.5048 3.19922 22.9079 3.19922 24.4076Z",
    fill: "url(#paint2_linear_25864_18912)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25864_18912",
    x1: 9.47198,
    y1: -17.4386,
    x2: 9.47198,
    y2: 45.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C16C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25864_18912",
    x1: 9.98491,
    y1: -1.14893,
    x2: 9.98491,
    y2: 2.77659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C16C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25864_18912",
    x1: 11.1992,
    y1: 20.0088,
    x2: 11.1992,
    y2: 38.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996D73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFormulaList);
export default __webpack_public_path__ + "static/media/ic-formula-list.95f39519e1e4e8ddc75a79c805d49dc2.svg";
export { ForwardRef as ReactComponent };